import { Snackbar, Alert, styled } from '@tino-frontend/coreui'

export const SnackbarRoot = styled(Snackbar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer * 2,
}))

export const AlertRoot = styled(Alert)(({ theme }) => {
  return {
    borderRadius: theme.shape.borderRadiusMedium,
    alignItems: 'flex-start',

    [theme.breakpoints.up('md')]: {
      minWidth: 350,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },

    '& .MuiAlert-action': {
      marginTop: theme.spacing(0.5),
    },
  }
})
